import React from "react";
import { Box, BoxProps, Text } from "@chakra-ui/react";
import { useLandingTheme } from "../../LandingThemeContext";
import { QuestionCardMock } from "../themed/QuestionCardMock";

// The transformation the product performs: a real lecture slide behind, the generated question in front.
// The sentence the question was drawn from is marked on the slide, in the strip left visible above the card.
export function SlideToQuestion(props: BoxProps) {
  const theme = useLandingTheme();
  return (
    <Box position="relative" pt={{ base: "120px", md: "150px" }} pl={{ base: "24px", md: "56px" }} {...props}>
      <Box
        aria-hidden="true"
        position="absolute"
        top={0}
        left={0}
        right={{ base: "24px", md: "40px" }}
        h={{ base: "260px", md: "300px" }}
        bg={theme.color.surface}
        border={theme.card.border}
        borderRadius={theme.shape.cardRadius}
        overflow="hidden"
        px="22px"
        py="18px"
        fontFamily={theme.font.body}
        color={theme.color.text}
      >
        <Text fontSize="11px" fontWeight={600} letterSpacing="0.08em" textTransform="uppercase" color={theme.color.muted}>
          Lecture 7 · slide 14
        </Text>
        <Text mt="4px" fontSize="17px" fontWeight={700} color={theme.color.heading} lineHeight={1.25}>
          Digestion and absorption
        </Text>
        <Box mt="10px" fontSize="13px" lineHeight={1.5} pl="14px" sx={{ "& > p": { position: "relative" }, "& > p::before": { content: '"•"', position: "absolute", left: "-12px", color: theme.color.muted } }}>
          <Text>
            <Box as="mark" bg={theme.color.accentSoft} color={theme.color.heading} px="2px" borderRadius="2px">
              The small intestine absorbs most nutrients through its villi and microvilli.
            </Box>
          </Text>
          <Text mt="4px">Stomach: pepsin begins protein digestion.</Text>
        </Box>
      </Box>
      <QuestionCardMock
        position="relative"
        showFormatLabel={false}
        bg={theme.isDark ? theme.color.surfaceAlt : theme.color.surface}
        boxShadow={theme.card.shadow === "none" ? (theme.isDark ? "0 32px 64px rgba(0, 0, 0, 0.5)" : "0 24px 48px rgba(0, 0, 0, 0.12)") : theme.card.shadow}
      />
    </Box>
  );
}
